function getHashFilter() {
  var hash = location.hash;
  // get filter=filterName
  var matches = location.hash.match(/filter=([^&]+)/i);
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent(hashFilter);
}

(function($) {

  $(window).on('load', function() {

    if (!!$.prototype.isotope) {
      // Isotope is initialized

      // Tooltips
      $(function() {
        $('[data-toggle="tooltip"]').tooltip()
      })

      $(function() {

        var $container = $('#isotope'),
          filters = {},
          hashSelector = window.location.hash.slice(1);

        // filter buttons
        $('.filters select').change(function() {
          var $this = $(this);

          // store filter value in object
          // i.e. filters.color = 'red'
          var group = $this.attr('data-filter-group');

          filters[group] = $this.find(':selected').attr('value');
          // console.log( $this.find(':selected') )
          // convert object into array
          var isoFilters = [];
          for (var prop in filters) {
            isoFilters.push(filters[prop]);
          }

          // log filters to console (Performance heavy)
          // console.log(filters);

          var selector = isoFilters.join('');
          $container.isotope({
            filter: selector
          });

          // replace multiple asterisk with single in selector
          var hash = selector.replace(/\*+/g, "*");

          // set filter in hash
          window.location.hash = 'filter=' + encodeURIComponent(hash);

          return false;
        });


        var isIsotopeInit = false;

        function onHashchange() {
          var hashFilter = getHashFilter();
          if (!hashFilter && isIsotopeInit) {
            return;
          }
          isIsotopeInit = true;
          // filter isotope
          $container.isotope({
            itemSelector: '.isotope-item',
            filter: hashFilter
          });
          // set selected class

          if (hashSelector) {
            // console.log(hashSelector);

            // FIXME: Resetting after coming from other page with hashlink leaves filters stuck
            var selectorClasses = hashSelector.split('.').slice(1);
            $.each(selectorClasses, function(i, selectorClass) {

              $('option[data-filter-value=".' + selectorClass + '"]').parent('.filter-group').val('.' + selectorClass).trigger('change');

              // console.log($('option[data-filter-value=".' + selectorClass + '"]').parent('.filter-group'));

              return true;
            });

            // Reset classes
            selectorClasses = "";

          }


        }
        // Reset all filters
        $("#isotope-reset").click(function() {
          $container.isotope({
            filter: ''
          });
          $('.selected').removeClass('selected');
          $('.filter-group').val('').trigger('change');

          // Reset hasfilter
          hashFilter = "";

        });

        $(window).on('hashchange', onHashchange);

        // trigger event handler to init Isotope
        onHashchange();

      });

    }

  });

})(jQuery);